import { Contractors } from "@timesheets/webapp-support";
import { INotifyOptions } from "@/utils/Form";

export const notify: INotifyOptions<Contractors.DeleteContractor.IDeleteContractorForm, undefined> = {
  success: "Contractor deleted",
  failure: "Could not delete contractor",
};
